import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

import { GRAPHCOLOURS } from './graph.colours';

@Component({
    selector: 'mlp-ng-graph',
    templateUrl: './graph.component.html',
    styleUrls: ['./graph.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class GraphSharedComponent implements OnInit {
    @Input() graph;

    ngOnInit(): void {
        this.graph.chartOptions = {
            responsive: true
        };
        this.graph.chartColors = (!this.graph.chartColors) ? GRAPHCOLOURS : this.graph.chartColors;
        Object.assign(this.graph.chartColors, GRAPHCOLOURS);
    }
}
